// extracted by mini-css-extract-plugin
module.exports = {"map":"SaveSuccessModal_map__uswcT","wrapper":"SaveSuccessModal_wrapper__LzIMm"};